import { LegalLayout, LegalSection } from "@/components/LegalLayout";
import { CAMPAIGN, LEGAL } from "@/config/campaign";

export default function Impressum() {
  return (
    <LegalLayout title="Impressum" testId="imprint-page">
      <LegalSection title="Angaben">
        <p data-testid="legal-entity">
          ChickenWinner.ch
          <br />
          Zürich, Schweiz
        </p>
        <p className="font-display text-lg font-bold tracking-tight text-gold-dark">{CAMPAIGN.slogan}</p>
      </LegalSection>
      <LegalSection title="Kontakt">
        <p>E-Mail: {LEGAL.email}</p>
        <p>Instagram: {CAMPAIGN.instagramHandle}</p>
      </LegalSection>
    </LegalLayout>
  );
}
